import Axios from "axios";
var NotifyService = (function () {
    function NotifyService() {
    }
    NotifyService.prototype.getNoticeDetail = function (params) {
        return Axios.get("supplierclientapi/notice/detail", { params: params });
    };
    NotifyService.prototype.confirmNotify = function (params) {
        return Axios.get("supplierclientapi/notice/confirm", { params: params });
    };
    NotifyService.createInstance = function () {
        NotifyService.getInstance();
    };
    NotifyService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return NotifyService;
}());
export default NotifyService;
